import { DateTimePickerProps, DateTimePicker as MuiDateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import React, { ReactNode } from 'react';
import { TID_ATTR } from '@/common/infrastructure/config/tid';

export type CustomDateTimePickerProps = DateTimePickerProps<Date> & {
  fullWidth?: boolean;
  helperText?: ReactNode;
  id?: string;
  onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  error?: boolean;
  testId?: string;
};

const DateTimePicker: React.FC<CustomDateTimePickerProps> = ({ fullWidth = false, helperText, id, onBlur, error, testId, ...rest }) => {
  const { slotProps: incomingSlotProps, ...restProps } = rest as { slotProps?: { textField?: Record<string, unknown> } };

  const testIdSlotProps = testId
    ? {
        textField: {
          inputLabel: { [TID_ATTR]: `${testId}:label` },
          htmlInput: { [TID_ATTR]: `${testId}:input` },
          formHelperText: { [TID_ATTR]: `${testId}:helper-text` }
        },
        openPickerButton: { [TID_ATTR]: `${testId}:open-button` },
        popper: { [TID_ATTR]: `${testId}:popper` },
        desktopPaper: { [TID_ATTR]: `${testId}:desktop-paper` },
        layout: { [TID_ATTR]: `${testId}:layout` },
        calendarHeader: { [TID_ATTR]: `${testId}:calendar-header` }
      }
    : {};

  const mergedSlotProps = {
    ...(incomingSlotProps ?? {}),
    ...testIdSlotProps,
    textField: {
      ...(incomingSlotProps?.textField ?? {}),
      ...(testIdSlotProps.textField ?? {}),
      id: id,
      fullWidth: fullWidth,
      error: error,
      helperText: helperText,
      inputProps: {
        ...(incomingSlotProps?.textField?.inputProps ?? {}),
        ...(testId ? { [TID_ATTR]: `${testId}:input` } : {})
      },
      slotProps: {
        ...(incomingSlotProps?.textField?.slotProps ?? {}),
        ...(testIdSlotProps.textField || {})
      },
      onBlur: onBlur
    }
  };

  return <MuiDateTimePicker {...restProps} slotProps={mergedSlotProps as unknown as DateTimePickerProps<Date>['slotProps']} />;
};

export default DateTimePicker;
